import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Récupération de l'élément root
const rootElement = document.getElementById("root");

if (!rootElement) {
    throw new Error("Erreur : Aucun élément avec l'id 'root' n'a été trouvé dans le document HTML.");
}


ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <BrowserRouter>
                <App />
        </BrowserRouter>
    </React.StrictMode>
);